import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../shared/types/api.types'
import { validateUspsAddressApi } from './validateUspsAddress.api'
import validateUspsAddressInitialState from './validateUspsAddress.initialState'
import { ValidateUspsAddressErrorResponse, ValidateUspsAddressRequestPayload } from './validateUspsAddress.types'

export const validateUspsAddress = createAsyncThunk(
  urls.usps.validateAddress,
  async (payload: ValidateUspsAddressRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess, onError } = payload

    try {
      const response = await validateUspsAddressApi(request)

      onSuccess?.(response)

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse, onError, true)

      return rejectWithValue(error)
    }
  }
)

const validateUspsAddressSlice = createSlice({
  name: urls.usps.validateAddress,
  initialState: validateUspsAddressInitialState,
  reducers: {
    resetValidateUspsAddress: (state) => {
      state.loading = false
      state.error = null
      state.success = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(validateUspsAddress.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(validateUspsAddress.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(validateUspsAddress.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as ValidateUspsAddressErrorResponse
        state.success = null
      })
  }
})

export const { actions: validateUspsAddressActions, reducer: validateUspsAddressReducer } = validateUspsAddressSlice
export const { resetValidateUspsAddress } = validateUspsAddressActions
export default validateUspsAddressSlice.reducer
